// extracted by mini-css-extract-plugin
export var aboutEditorialGuidelines = "n_8";
export var aboutFAQ = "n_7";
export var aboutPage = "n_4";
export var aboutTrustpilot = "n_9";
export var aboutWhoWeAre = "n_5";
export var aboutWhoWeAreContent = "n_6";